// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'open';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M7.289 10.57 16 2m0 4.898V2h-4.978M9.078 5.111H2.544A.544.544 0 0 0 2 5.656v9.8a.544.544 0 0 0 .544.544h9.8a.545.545 0 0 0 .545-.544V8.922'
  />
);

export const viewBox = '0 0 18 18';
